import { format, isValid, parse, startOfDay } from "date-fns";

export const DATE_FORMAT = "dd.MM.yyyy";
export const URL_DATE_FORMAT = "yyyy-MM-dd";

/** Page size used by quick / ISBN search when none is in the URL. */
export const DEFAULT_PAGE_SIZE = 10;

/**
 * Hybrid search benefits from a wider RRF window: more results visible at
 * once produces better cross-signal coverage. This MUST stay in sync with
 * `HybridBooksTable`'s `<PaginationController defaultPageSize>` so the
 * URL/UI default and the API default agree.
 */
export const HYBRID_DEFAULT_PAGE_SIZE = 50;

/**
 * Fixed semantic shelf size: book groups returned for every semantic search.
 * Counts work groups, not edition rows. Distinct from the backend safety
 * ceiling (`SEMANTIC_MAX_GROUPS` = 100 in search.py).
 */
export const SEMANTIC_SEARCH_PAGE_SIZE = 20;

export function parseInputDate(value: string): Date | undefined {
  const parsed = parse(value, DATE_FORMAT, new Date());
  return isValid(parsed) && format(parsed, DATE_FORMAT) === value
    ? startOfDay(parsed)
    : undefined;
}

export function formatUrlDate(ddMMyyyy: string): string {
  const parsed = parseInputDate(ddMMyyyy);
  if (!parsed) {
    throw new Error(`Invalid UI date: "${ddMMyyyy}" (expected ${DATE_FORMAT})`);
  }
  return format(parsed, URL_DATE_FORMAT);
}

export function parseUrlDate(yyyyMMdd: string): string {
  const parsed = parse(yyyyMMdd, URL_DATE_FORMAT, new Date());
  if (!isValid(parsed)) {
    throw new Error(
      `Invalid URL date: "${yyyyMMdd}" (expected ${URL_DATE_FORMAT})`,
    );
  }
  return format(parsed, DATE_FORMAT);
}

export function parseToUTCDate(dateStr: string, isEndOfDay: boolean): Date {
  const parsedDate = parseInputDate(dateStr);

  if (!parsedDate) {
    throw new Error(
      `Invalid date format: "${dateStr}" (expected ${DATE_FORMAT})`,
    );
  }

  return new Date(
    Date.UTC(
      parsedDate.getFullYear(),
      parsedDate.getMonth(),
      parsedDate.getDate(),
      isEndOfDay ? 23 : 0,
      isEndOfDay ? 59 : 0,
      isEndOfDay ? 59 : 0,
    ),
  );
}
